<template>
  <div class="firewall-autocase-container">

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <svg-icon icon-class="firewall" /> Compliance firewall auto settings
      </div>
      <div v-loading="loading">

        <el-form ref="settingForm" :model="settingForm" label-width="150px" size="mini">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span><i class="el-icon-success" style="color:#409EFF"></i> Firewall auto case</span>
                </div>
                <div>

                  <el-divider content-position="left">Large payment</el-divider>
                  <el-form-item label="ON">
                    <el-switch v-model="settingForm.firewall_autocase_setup.largepayment.on"></el-switch>
                  </el-form-item>
                  <el-form-item label="Duration">
                    <el-input-number v-model="settingForm.firewall_autocase_setup.largepayment.duration"
                      :min="1"></el-input-number>
                  </el-form-item>

                  <el-divider content-position="left">Large payment onetime</el-divider>
                  <el-form-item label="ON">
                    <el-switch v-model="settingForm.firewall_autocase_setup.largepayment_onetime.on"></el-switch>
                  </el-form-item>
                  <el-form-item label="Duration">
                    <el-input-number v-model="settingForm.firewall_autocase_setup.largepayment_onetime.duration"
                      :min="1"></el-input-number>
                  </el-form-item>

                  <el-divider content-position="left">Diligent</el-divider>
                  <el-form-item label="ON">
                    <el-switch v-model="settingForm.firewall_autocase_setup.diligent.on"></el-switch>
                  </el-form-item>
                  <el-form-item label="Duration">
                    <el-input-number v-model="settingForm.firewall_autocase_setup.diligent.duration"
                      :min="1"></el-input-number>
                  </el-form-item>

                  <el-divider content-position="left">Blacklist</el-divider>
                  <el-form-item label="ON">
                    <el-switch v-model="settingForm.firewall_autocase_setup.blacklist.on"></el-switch>
                  </el-form-item>
                  <el-form-item label="Duration">
                    <el-input-number v-model="settingForm.firewall_autocase_setup.blacklist.duration"
                      :min="1"></el-input-number>
                  </el-form-item>

                  <el-divider content-position="left">Whitelist</el-divider>
                  <el-form-item label="ON">
                    <el-switch v-model="settingForm.firewall_autocase_setup.whitelist.on"></el-switch>
                  </el-form-item>
                  <el-form-item label="Duration">
                    <el-input-number v-model="settingForm.firewall_autocase_setup.whitelist.duration"
                      :min="1"></el-input-number>
                  </el-form-item>

                  <el-divider content-position="left">Risk country</el-divider>
                  <el-form-item label="ON">
                    <el-switch v-model="settingForm.firewall_autocase_setup.riskcountry.on"></el-switch>
                  </el-form-item>
                  <el-form-item label="Duration">
                    <el-input-number v-model="settingForm.firewall_autocase_setup.riskcountry.duration"
                      :min="1"></el-input-number>
                  </el-form-item>

                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span><i class="el-icon-warning" style="color:#E6A23C"></i> Firewall auto case exception</span>
                </div>
                <div>
                  <el-checkbox-group v-model="selectedExceptionDays">
                    <div v-for="(dayName, dayIndex) in daysOfWeek" :key="dayIndex">
                      <el-divider content-position="left">
                        <el-checkbox :label="dayIndex">{{ dayName }}</el-checkbox>
                      </el-divider>
                      <el-form-item :label="`Start Time`" style="margin-bottom: 5px;">
                        <el-time-picker                  
                         v-model="exceptionTimeRanges[dayIndex].startTime"
                         :picker-options="{
                          start: '00:00',
                          step: '00:01',
                          end: '23:59'
                        }" 
                        placeholder="Select time" 
                        format="HH:mm" 
                        value-format="HH:mm" 
                        :disabled="!isDaySelected(dayIndex)"
                        >
                        </el-time-picker>
                      </el-form-item>
                      <el-form-item :label="`End Time`" style="margin-bottom: 5px;">
                        <el-time-picker 
                        v-model="exceptionTimeRanges[dayIndex].endTime"
                        :picker-options="{
                          start: '00:00',
                          step: '00:01',
                          end: '23:59'
                        }" 
                        placeholder="Select time" 
                        format="HH:mm" 
                        value-format="HH:mm" 
                        :disabled="!isDaySelected(dayIndex)">
                        </el-time-picker>
                      </el-form-item>
                    </div>
                  </el-checkbox-group>


                </div>
              </el-card>
            </el-col>
            <el-col :span="24">
              <div style="margin-top:20px;" class="text-center">
                <el-button type="primary" @click="onSubmit" :loading="submitting">Submit</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

  </div>
</template>

<script>
import {getFirewallSettingAutoCase, postFirewallSettingAutoCase} from '@/api/firewall'
export default {
  data() {
    const initialExceptionTimeRanges = {};
    for (let i = 0; i < 7; i++) {
      initialExceptionTimeRanges[i] = { startTime: '00:00', endTime: '23:59' };
    }

    return {
      loading: false,
      submitting: false,
      selectedExceptionDays: [],
      exceptionTimeRanges: initialExceptionTimeRanges, 
      daysOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      value: "", 
      settingForm: {
        "firewall_autocase_setup": {
          "largepayment": { "on": true, "duration": 72 },
          "diligent": { "on": true, "duration": 72 },
          "largepayment_onetime": { "on": true, "duration": 72 },
          "blacklist": { "on": true, "duration": 72 },
          "riskcountry": { "on": true, "duration": 72 },
          "whitelist": { "on": true, "duration": 24 },
        },
        "firewall_autocase_exception": [
          {
            "exception_time_start": { "day": 5, "hour": 12, "minute": 55 }, // Friday
            "exception_time_end": { "day": 5, "hour": 12, "minute": 55 }
          },
          {
            "exception_time_start": { "day": 6, "hour": 13, "minute": 55 }, // Saturday
            "exception_time_end": { "day": 6, "hour": 13, "minute": 55 }
          },
          {
            "exception_time_start": { "day": 1, "hour": 8, "minute": 0 }, // Monday
            "exception_time_end": { "day": 1, "hour": 17, "minute": 0 }
          }
        ]
      },
    };
  },
  watch: {
    selectedExceptionDays(newVal, oldVal) {
      // Find days that were just unselected
      const unselectedDays = oldVal.filter(day => !newVal.includes(day));
      unselectedDays.forEach(day => {
        // Clear time for unselected days by resetting to empty object
        // Use $set to ensure reactivity if we were adding new properties,
        // but here we are just modifying existing properties (startTime, endTime)
        // or resetting the object for that day.
        // It's safer to ensure the object exists and then clear its properties.
        if (this.exceptionTimeRanges[day]) {
            this.exceptionTimeRanges[day].startTime = '';
            this.exceptionTimeRanges[day].endTime = '';
        }else{
          this.exceptionTimeRanges[day].startTime = '00:00';
            this.exceptionTimeRanges[day].endTime = '23:59';
        }
      });

      // For newly selected days, their time ranges are already initialized
      // in data() or when populateExceptionForm runs.
      // No need to add new objects here, just ensuring they are active for input.
    }
  },
  methods: {
    isDaySelected(dayIndex) {
      return this.selectedExceptionDays.includes(dayIndex);
    },
    onSubmit() {
      this.submitting = true;
      var model = JSON.parse(JSON.stringify(this.settingForm))
      model.firewall_autocase_exception = []; // Clear previous exceptions

      // Sort selected days for consistent output
      this.selectedExceptionDays.sort((a, b) => a - b);

      this.selectedExceptionDays.forEach(dayIndex => {
        const timeRange = this.exceptionTimeRanges[dayIndex];
        // Only add if day is selected and both start/end times are set
        if (timeRange && timeRange.startTime && timeRange.endTime) {
          const startParts = timeRange.startTime.split(':');
          const endParts = timeRange.endTime.split(':');

          model.firewall_autocase_exception.push({
            exception_time_start: {
              day: dayIndex, 
              hour: parseInt(startParts[0]),
              minute: parseInt(startParts[1])
            },
            exception_time_end: {
              day: dayIndex,
              hour: parseInt(endParts[0]),
              minute: parseInt(endParts[1])
            }
          });
        }
      });

      postFirewallSettingAutoCase(model).then(({result, data, message})=>{
        this.submitting = false;
        if(result){
          this.loadData()
        }else{
          this.$notify({
              title: "Error",
              message: message,
              type: "error",
              duration: 2000,
            });
        }
      }).catch((error)=>{
        this.submitting = false;
        this.$notify({
              title: "Error",
              message: error.message || "Load data error",
              type: "error",
              duration: 2000,
            });
      })

      
    },
    loadData(){
      this.loading = true;
      getFirewallSettingAutoCase().then(({result, data, message})=>{
        this.loading = false;
        if(result){
          this.settingForm = data; // Set the loaded data to settingForm
          this.setupException();
        }else{
          this.$notify({
              title: "Error",
              message: message,
              type: "error",
              duration: 2000,
            });
        }
      }).catch((error)=>{
        this.loading = false;
        this.$notify({
              title: "Error",
              message: error.message || "Load data error",
              type: "error",
              duration: 2000,
            });
      })

     

    },
    setupException(){

      // Clear previous selections and time ranges for a clean load
      this.selectedExceptionDays = []; 
      // Re-initialize all time ranges to empty for a clean slate before populating
      for (let i = 0; i < 7; i++) {
        this.$set(this.exceptionTimeRanges, i, { startTime: '', endTime: '' });
      }

      if (this.settingForm.firewall_autocase_exception && this.settingForm.firewall_autocase_exception.length > 0) {
        // Group exceptions by day
        const groupedExceptions = {};
        this.settingForm.firewall_autocase_exception.forEach(ex => {
          const day = ex.exception_time_start.day;
          // As discussed, assuming one time range per day for this UI.
          // If multiple exist, the last one for that day will be used.
          groupedExceptions[day] = {
            startTime: `${String(ex.exception_time_start.hour).padStart(2, '0')}:${String(ex.exception_time_start.minute).padStart(2, '0')}`,
            endTime: `${String(ex.exception_time_end.hour).padStart(2, '0')}:${String(ex.exception_time_end.minute).padStart(2, '0')}`
          };
        });

        // Populate selectedExceptionDays and exceptionTimeRanges
        for (const dayIndex in groupedExceptions) {
          if (groupedExceptions.hasOwnProperty(dayIndex)) {
            const dayNum = parseInt(dayIndex);
            this.selectedExceptionDays.push(dayNum);
            // Directly assign to the pre-initialized object
            this.exceptionTimeRanges[dayNum].startTime = groupedExceptions[dayIndex].startTime;
            this.exceptionTimeRanges[dayNum].endTime = groupedExceptions[dayIndex].endTime;
          }
        }
        // Sort selected days for consistent display
        this.selectedExceptionDays.sort((a, b) => a - b);
      }
    }
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss">
.firewall-autocase-container {
  .el-tag {
    text-transform: capitalize;
  }
}
</style>